import { removeIndexedDbPromise } from '@/utilities/removeIndexedDbPromise';

import { cleanComplete } from '../../actions/completions/CleanComplete';
import { kind as restart } from '../../actions/goals/Restart';
import { kind as start } from '../../actions/goals/Start';
import { reject } from '../../GoalResolvers';
import { rxdb16DatabaseName } from '../../initializeDB';
import { State } from '../../State';
import { Task } from '../../Task';
import { destroy } from './destroy';
import { notIdle } from './notIdle';
import { suspend } from './suspend';

export const kind = 'Clean';

export function cleanTask(): Task {
  return {
    kind: start,
    start: async dispatch => {
      await removeIndexedDbPromise(rxdb16DatabaseName);
      dispatch(cleanComplete);
    },
  };
}

export function clean(state: State): State {
  let goalResolvers = state.goalResolvers;
  const reason = 'Cleaning';
  goalResolvers = reject(goalResolvers, start, reason);
  goalResolvers = reject(goalResolvers, restart, reason);

  if (state.replication) return suspend({ ...state, goalResolvers });
  if (state.database) return destroy({ ...state, goalResolvers });

  return {
    ...state,
    goalResolvers,
    nextTask: cleanTask(),
    whenIdle: notIdle(state),
  };
}
